import { useMutation, useQueryClient } from '@tanstack/react-query';
import API from '../../../context/API';
import { STORES_QUERY_KEY } from './useStores';
import type { CreateStorePayload, UpdateStorePayload, Store } from '../store/userStoresSlice';

export const useCreateStore = () => {
  const queryClient = useQueryClient();
  return useMutation<Store, string, CreateStorePayload>({
    mutationFn: async (payload) => {
      const res = await API.post('/stores', payload);
      if (res.data.success) return res.data.data;
      throw res.data.message || 'Failed to create store';
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: STORES_QUERY_KEY });
    },
  });
};

export const useUpdateStore = () => {
  const queryClient = useQueryClient();
  return useMutation<Store, string, UpdateStorePayload>({
    mutationFn: async ({ id, ...data }) => {
      const res = await API.patch(`/stores/${id}`, data);
      if (res.data.success) return res.data.data;
      throw res.data.message || 'Failed to update store';
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: STORES_QUERY_KEY });
    },
  });
};

export const useDeleteStore = () => {
  const queryClient = useQueryClient();
  return useMutation<string, string, string>({
    mutationFn: async (storeId) => {
      const res = await API.delete(`/stores/${storeId}`);
      if (res.data.success) return storeId;
      throw res.data.message || 'Failed to delete store';
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: STORES_QUERY_KEY });
    },
  });
};
